/**
 * @generated SignedSource<<0cb21ba1095c2ee9c4f46c3c3363ae77>>
 * @relayHash 0970864457fdee284d8cd2646a2b5b25
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/567.0.0-2026-07-09T16:56:40.805Z/DesignerDirectorySearchRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectorySearchRefetchQuery$variables = {
  hasSearch: boolean;
  search: string;
  showOnlyTpnFirms?: boolean | null;
  showTestFirms?: boolean | null;
};
export type DesignerDirectorySearchRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectorySearch_viewer">;
  };
};
export type DesignerDirectorySearchRefetchQuery = {
  response: DesignerDirectorySearchRefetchQuery$data;
  variables: DesignerDirectorySearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showOnlyTpnFirms"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showTestFirms"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DesignerDirectorySearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DesignerDirectorySearch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DesignerDirectorySearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasSearch",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "designFirmResults",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "firmName",
                    "variableName": "search"
                  },
                  {
                    "kind": "Variable",
                    "name": "showOnlyTpnFirms",
                    "variableName": "showOnlyTpnFirms"
                  },
                  {
                    "kind": "Variable",
                    "name": "showTestFirms",
                    "variableName": "showTestFirms"
                  }
                ],
                "concreteType": "DirectoryDesignFirmConnection",
                "kind": "LinkedField",
                "name": "designFirms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DirectoryDesignFirmEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DirectoryDesignFirm",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DesignFirmPublicProfile",
                            "kind": "LinkedField",
                            "name": "publicProfile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlLabel",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/567.0.0-2026-07-09T16:56:40.805Z/DesignerDirectorySearchRefetchQuery",
    "metadata": {},
    "name": "DesignerDirectorySearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "99b5d84db40f99f1c05128d41cc62ee7";

export default node;
